var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcSoundOn = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17.319 7.101a.75.75 0 0 1 .41.669v16.46a.75.75 0 0 1-1.192.606l-5.564-4.053H7.371a2.5 2.5 0 0 1-2.5-2.5v-4.566a2.5 2.5 0 0 1 2.5-2.5h3.602l5.564-4.053a.75.75 0 0 1 .782-.063m-1.09 2.143-4.57 3.33a.75.75 0 0 1-.441.143H7.37a1 1 0 0 0-1 1v4.566a1 1 0 0 0 1 1h3.847a.75.75 0 0 1 .441.144l4.57 3.329zm3.563 2.914a.75.75 0 0 0 .257 1.029c1.245.746 1.797 1.814 1.797 2.813s-.552 2.067-1.797 2.814a.75.75 0 1 0 .772 1.286c1.636-.982 2.525-2.507 2.525-4.1s-.889-3.118-2.525-4.1a.75.75 0 0 0-1.029.258m2.522-2.454a.75.75 0 1 1 .852-1.234c5.439 3.754 5.45 11.307 0 15.061a.75.75 0 1 1-.852-1.235c4.583-3.156 4.577-9.433 0-12.592",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcSoundOn);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };